// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip__OlLxw","simpleAudioButtonImage":"simpleAudioButtonImage__FZ8u6","htmlAudioImage":"htmlAudioImage__SYAD6","hint":"hint___jBtY"};